/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BillingSettingsContainer_invoiceSettings$ref: FragmentReference;
declare export opaque type BillingSettingsContainer_invoiceSettings$fragmentType: BillingSettingsContainer_invoiceSettings$ref;
export type BillingSettingsContainer_invoiceSettings = {|
  +id: string,
  +wiringInstructions: ?string,
  +contactPerson: string,
  +contactPhoneNumber: string,
  +contactEmail: string,
  +$refType: BillingSettingsContainer_invoiceSettings$ref,
|};
export type BillingSettingsContainer_invoiceSettings$data = BillingSettingsContainer_invoiceSettings;
export type BillingSettingsContainer_invoiceSettings$key = {
  +$data?: BillingSettingsContainer_invoiceSettings$data,
  +$fragmentRefs: BillingSettingsContainer_invoiceSettings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BillingSettingsContainer_invoiceSettings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wiringInstructions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactPerson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactPhoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactEmail",
      "storageKey": null
    }
  ],
  "type": "InvoiceSettings"
};
// prettier-ignore
(node/*: any*/).hash = 'd74a5f3207b70bbda3475f379a24d822';

module.exports = node;
